import { Controller } from '@hotwired/stimulus';
import { rebuildPaymentElement } from '../../modules/checkout/stripe';

export default class extends Controller {
  static targets = ['stripeElementForm']

  connect () {
    this.loadForm();
  }

  // eslint-disable-next-line class-methods-use-this
  loadForm () {
    rebuildPaymentElement();
  }
}
